import * as  React from 'react';
import { getResolutionName } from '../../containers/WorkkardDetail/utils';
import { fetchTimezoneAbbreviation } from "../../common/util";
import UserImage from '../UserImage/index';

export default class AssociatedWorkkardMobileCell extends React.Component {
    timeOut = null;

    onMouseEnter = (e,id) => {
        const targetRect = e.currentTarget.getBoundingClientRect();
        this.timeOut = setTimeout(() => this.props.onItemClick(targetRect,id),500)
    }

    onMouseLeave = () => {
        clearTimeout(this.timeOut)
    }

    render(){
        const {data,key} = this.props;
        return(
            <>
            <div key={key} className={`pabcdnone card ${!data.isViewable ? 'disableText':''}`}>
                <div className="rowSpaceBetween alignMiddle">
                    <div className="dFlex">
                        {data.isViewable ? (<a href={`/getclmdetail?cId=${data.wkId}`} className="orange commercialWk ">{data.wkNumber}</a>) : data.wkNumber }
                        <div className={`status ml__1 ${data.isViewable ? data.wkStatus.toLowerCase() : ''}`}>{getResolutionName(data.wkStatus)}</div>
                    </div>
                    <div className="pointer" >
                        <div className="rowFlex alignMiddle ">
                            <div onMouseEnter={(e) => this.onMouseEnter(e, data.sponsorId)} onMouseLeave={this.onMouseLeave} className="userPic userPicIcon">
                                <UserImage profileUrl={data.profileImageUrl}size="24" profileName={data.sponsorName}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="alignMiddle alignStart mt">
                    <div className="lossDate"><label>Loss Date</label> {data.dynamicFields.lossdate_datetime && data.dynamicFields.lossdate_timezone  && (data.dynamicFields.lossdate_datetime + ' ' + fetchTimezoneAbbreviation(data.dynamicFields.lossdate_timezone))}</div>
                    <div><label>Loss Type</label> {data.dynamicFields && data.dynamicFields.losstype_singlechoicelist}</div>
                </div>
            </div>
            </>
        );
    }
}
